import { render } from "./WizardModal.vue?vue&type=template&id=2808a58e"
import script from "./WizardModal.vue?vue&type=script&lang=js"
export * from "./WizardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__